import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";
import { Edit2, Eye, MoreVertical, Trash2 } from "lucide-react";

export default function ActionDropdown({ actions = {}, onEdit, onView, onDelete }) {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  const handleToggle = () => {
    if (!isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const dropdownWidth = 100;
      const left = rect.left + window.scrollX - dropdownWidth;
      const top = rect.bottom + window.scrollY;
      setCoords({ top, left });
    }
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button
        ref={buttonRef}
        onClick={handleToggle}
        className="px-5"
      >
        <MoreVertical className="w-4 h-4 text-gray-600" />
      </button>

      {isOpen &&
        createPortal(
          <>
            {/* Backdrop */}
            <div
              className="fixed inset-0 z-40"
              onClick={() => setIsOpen(false)}
            />

            {/* Dropdown */}
            <div
              className="absolute w-32 bg-white rounded-md shadow-lg border border-gray-200 z-50 "
              style={{ top: coords.top, left: coords.left }}
            >
              <div className="py-1">
                {actions.edit && (
                  <button
                    onClick={() => {
                      onEdit();
                      setIsOpen(false);
                    }}
                    className="flex items-center w-full px-4 py-2 text-sm text-black hover:bg-sidebarHover hover:text-primary"
                  >
                    <Edit2 className="w-4 h-4 mr-2" />
                    Edit
                  </button>
                )}

                {actions.view && (
                  <button
                    onClick={() => {
                      onView();
                      setIsOpen(false);
                    }}
                    className="flex items-center w-full px-4 py-2 text-sm text-black hover:bg-sidebarHover hover:text-primary"
                  >
                    <Eye className="w-4 h-4 mr-2" />
                    View
                  </button>
                )}

                {actions.delete && (
                  <button
                    onClick={() => {
                      onDelete();
                      setIsOpen(false);
                    }}
                    className="flex items-center w-full px-4 py-2 text-sm text-black hover:bg-sidebarHover hover:text-primary"
                  >
                    <Trash2 className="w-4 h-4 mr-2" />
                    Delete
                  </button>
                )}
              </div>
            </div>
          </>,
          document.body
        )}
    </>
  );
}
